export default __webpack_public_path__ + "justhatched-screens.06c6c388.png";